<template>
     <div class="pt_pagination">                                        
            <div class="btns">
                    <button class="navigate" :class="{'disabled': disablePrevious}" @click="previous">
                      <div class="flex">
                        <feather-icon icon="ChevronLeftIcon" svgClasses="w-6 h-6 text-light"></feather-icon>
                      </div>
                    </button>
                    <button class="page text-lg">
                      {{ `Page ${currentPageFilters.index + 1}` }} 
                    </button>               
                    <button class="navigate" :class="{'disabled': disableNext}" @click="next">
                      <div class="flex">
                        <feather-icon icon="ChevronRightIcon" svgClasses="w-6 h-6 text-light"></feather-icon>
                        </div>
                      </button>    
                    </div> 
                    <div class="w-full text-center text-lg my-1">
                      <span>{{ $store.state.dash.viewState.loadingFeedback ? 'Loading...' :  collectionText }}</span>
                    </div>                                 
    </div>
</template>


<script>

export default {
    data() {
        return {

        }
    },
    computed: {
        collectionText () {
            if (this.currentPageFilters.index === 0 && this.currentPageFilters.hasMore) {
                return `1 - ${this.currentPageFilters.perPage} of many`
            } else {
                if (this.currentPageFilters.hasMore) {
                    return `${(this.currentPageFilters.index * this.currentPageFilters.perPage) + 1} - ${(this.currentPageFilters.index + 1) * this.currentPageFilters.perPage} of many`
                } else {
                    const inCollection = this.$store.state.dash.viewData.viewFeedback.length
                    const limit = (this.currentPageFilters.index * this.currentPageFilters.perPage) + inCollection

                    if (inCollection === 0) {
                        return 'No results'
                        } else return `${(this.currentPageFilters.index * this.currentPageFilters.perPage) + 1} - ${limit} of ${limit}`
                }                
            }
        },        
        disableNext() {
            return !this.currentPageFilters.hasMore
        },
        disablePrevious() {
            return this.currentPageFilters.index === 0
        },
        currentPageFilters() {
            return this.$store.state.dash.viewState.viewResponseFilters.page
        }
    },
    methods: {
        next() {
            this.$store.commit('dash/CHANGE_PAGE_VIEW_FILTER', {
                filter: 'index',
                value: this.currentPageFilters.index + 1
            })            
            if (!this.$store.state.dash.viewData.feedbackEmpty) {                
                 this.$store.dispatch('dash/QUERY_FEEDBACK', {isInitialFetch: false, forceStartAfter: true})
            }
        },
        previous() {
            this.$store.commit('dash/CHANGE_PAGE_VIEW_FILTER', {
                filter: 'index',
                value: this.currentPageFilters.index - 1
            })
            if (!this.$store.state.dash.viewData.feedbackEmpty) {                
                 this.$store.dispatch('dash/QUERY_FEEDBACK', {isInitialFetch: false, forceStartAfter: true})
            }
        }
    }
}
</script>


